import { Tag } from '../Poll/Tag'

export type TagAndVoteCount = {
  tag: Tag
  voteCount: number
}

export interface InvestorStatistics {
  pollTagsVoteCount: TagAndVoteCount[]
}

export const sampleInvestorStatistics = (override?: Partial<InvestorStatistics>): InvestorStatistics => ({
  pollTagsVoteCount: [
    { tag: { title: 'Audit', id: '4' }, voteCount: 67 },
    { tag: { title: 'Environment', id: '6' }, voteCount: 42 },
    { tag: { title: 'Equality', id: '2' }, voteCount: 8 },
    { tag: { title: 'Lobbying', id: '8' }, voteCount: 2 },
  ],
  ...override,
})
